export default ($axios) => ({
    postIuteCreateOrder(data) {
        return $axios({
            method: 'POST',
            url: '/general/iute-credit/create-order/',
            data: data
        })
    },
})